<script>
import StoresServices from '@/services/stores'
import StoreNotificationsServices from '@/services/storeNotifications'
import EnvironmentUtils from '@/utils/environmentUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import StringUtils from '@/utils/stringUtils'
import DOMUtils from '@/utils/DOMUtils'
import ViewTitle from '@/components/ViewTitle'
import Checkbox from '@/components/Checkbox'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import StoreCard from '@/components/StoreCard'
import Fuse from 'fuse.js'

export default
{
    name: 'stores',

    created ()
    {
        StoresServices.fetchStores(EnvironmentUtils.cityId).then(stores  =>
        {
            this.$store.commit('stores/updateStoreList', stores)
        })
        StoreNotificationsServices.fetchStoreNotifications(EnvironmentUtils.cityId).then(notifs =>
        {
            this.$store.commit('storeNotifications/updateNotificationList', notifs)
        })

        this.fuse = new Fuse(this.stores.map(s => ({id: s.id, name: StringUtils.removeAccents(s.name)})), { threshold: 0.3, keys: ['name'] })
    },

    render () 
    {
        const storesByFirstLetter = {}
        for (let store of this.stores)
        {
            if (!storesByFirstLetter[store.name[0]]) storesByFirstLetter[store.name[0]] = []
            storesByFirstLetter[store.name[0]].push(store)
        }

        return (
            <div id='stores-view'>
                <view-title>Mes Commerces</view-title>
                <floating-label-text-input id='store-search-bar' class='light-gray-style' placeholder='Rechercher un commerce'
                    icon={require('@/assets/img/magnifying-glass-thin.svg')} placeholder-disappear-on-text={true} v-model={this.searchStoreBarValue} />
                <checkbox label='Recevoir les communications de mes commerces' v-model={this.$store.state.user.tags.notifiedOnStoreCommunication}
                    on-click={() => this.$store.commit('user/saveTags')} />
                <div id='store-list' ref='storeList'>
                {
                    Object.entries(storesByFirstLetter).sort((a, b) => a[0].localeCompare(b[0])).map(entry =>
                    {
                        const filteredStores = entry[1].filter(store => this.filteredStores.some(s => s.id == store.id))
                        if (filteredStores.length < 1) return

                        return <div class='stores-ordered-section'>
                            <div class='section-title'>{entry[0]}</div>
                            {filteredStores.sort((s1, s2) => s1.name.localeCompare(s2.name)).map(store => <store-card store={store} />)}
                        </div>
                    })
                }
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            searchStoreBarValue: '',
            fuse: null
        }
    },
    
    computed:
    {
        stores ()
        {
            return this.$store.state.stores.storeList.filter(s => s.cityId == EnvironmentUtils.cityId)
        },

        filteredStores ()
        {
            if (StringUtils.isEmptyString(this.searchStoreBarValue)) return this.stores

            return this.fuse.search(StringUtils.removeAccents(this.searchStoreBarValue))
        }
    },

    beforeRouteEnter (to, from, next)
    {
        next(vm =>
        {
            let storeList = vm.$refs.storeList
            
            if (LocalStorageUtils.useIntensiveAnimations)
            {
                let tiles = storeList.querySelectorAll('.image-tile')
                
                let delay = 0;

                tiles.forEach(tile =>
                {
                    tile.style.visibility = 'hidden'
                    setTimeout(() =>
                    {
                        tile.style.visibility = 'visible'
                        DOMUtils.animateCSS(tile, 'zoomIn', '0.3s')
                    }, delay)

                    delay += 100;
                })
            }
            else
            {
                storeList.style.transition = 'none'
                storeList.style.opacity = 0
                setTimeout(() =>
                {
                    storeList.style.transition = 'opacity 0.3s linear'
                    storeList.style.opacity = 1
                }, 100)
            }
        })
    }, 

    mounted ()
    {
    },

    methods:
    {
    },

    components:
    {
        ViewTitle,
        FloatingLabelTextInput,
        StoreCard,
        Checkbox
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#stores-view
{
    margin: 2% 6%;
    margin-bottom: 12vh;

    .OnTablet({
        margin: 2% 15%
    });

    .OnDesktop({
        margin: 2% 1.5%;
        margin-top: 5vw;
        margin-bottom: unset;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
        padding-left: 10vw;
        padding-right: 20vw;
    });

    .checkbox
    {
        margin-top: 20px;
    }

    #store-list
    {
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        .stores-ordered-section
        {
            margin: 10px 0;
            
            &:first-of-type
            {
                margin-top: 0;
            }

            .section-title
            {
                font-size: 18px;
                margin-bottom: 10px;
                font-weight: 600;
                color: var(--theme-background-text-color-heavy)
            }

            .store-card
            {
                margin: 5px 0%;
                
                &:first-of-type
                {
                    margin-top: 0;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Stores.vue